<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="p-4 lg:p-[30px] md:ml-64 mt-[63px] sm:mt-[66px] bg-white min-h-[calc(100vh-63px)] sm:min-h-[calc(100vh-66px)]">
    <router-outlet></router-outlet>
</div>